/**
 * Expose loader doesn’t map these to window.FLibs until we import them somewhere.
 * Until we figure out a better way, this file needs to be included on the charts page
 */
// eslint-disable-next-line react/no-typos
import 'classnames'
import { max, nice, scaleLinear, scaleSymlog } from 'd3'
import {
  add,
  addBusinessDays,
  differenceInCalendarDays,
  eachDayOfInterval,
  endOfDay,
  intervalToDuration,
  isSameMonth,
  isSameWeek,
  isWeekend,
  isWithinInterval,
  startOfDay,
  startOfYear,
  sub,
  subMonths,
  subYears,
} from 'date-fns'
import 'hammerjs'
// eslint-disable-next-line react/no-typos
import 'react'
import 'react-dom'
import * as ReactRouterDOM from 'react-router-dom'

import { getFormattedDateString } from '../app/header/utils'
import { decodeQueryString, encodeQueryString } from '../app/queryString'
import logo from '../app/shared/assets/logo.png'
import { getHoverChartImg } from '../app/shared/hover-chart'
import { getSanitizedTicker } from '../app/shared/ticker-sanitizer'
import { formatDateToStringUS, getIsDrawingEnabledOnQuotePage } from '../app/shared/utils'
import './components/index'
import { useSyncLocalStorage } from './hooks/use-sync-local-storage'
import * as localStorage from './services/local-storage'

declare const FLibs: any

FLibs.ReactRouterDOM = ReactRouterDOM
FLibs.getHoverChartImg = getHoverChartImg
FLibs.getSanitizedTicker = getSanitizedTicker
FLibs.decodeQueryString = decodeQueryString
FLibs.encodeQueryString = encodeQueryString
FLibs.getFormattedDateString = getFormattedDateString
FLibs.formatDateToStringUS = formatDateToStringUS
FLibs.useSyncLocalStorage = useSyncLocalStorage
FLibs.getIsDrawingEnabledOnQuotePage = getIsDrawingEnabledOnQuotePage
FLibs.localStorage = localStorage
FLibs.d3 = { max, nice, scaleLinear, scaleSymlog }
FLibs.DateFns = {
  add,
  addBusinessDays,
  differenceInCalendarDays,
  eachDayOfInterval,
  endOfDay,
  intervalToDuration,
  isSameMonth,
  isSameWeek,
  isWeekend,
  isWithinInterval,
  startOfDay,
  startOfYear,
  sub,
  subMonths,
  subYears,
}
FLibs.assets = {
  logo,
}
